var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"pf-button icon",attrs:{"type":"button"},on:{"click":_vm.goToPreviousStep}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"angle-left"}}),_vm._v(_vm._s(_vm.$t('back')))],1)}
var staticRenderFns = []

export { render, staticRenderFns }